import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule, ICellRendererAngularComp } from 'ag-grid-angular';
import { ClientSideRowModelModule, ColumnAutoSizeModule, CustomFilterModule, GridApi, GridOptions, ICellRendererParams, ModuleRegistry, RowSelectionOptions, TextFilterModule, ValidationModule, themeAlpine } from 'ag-grid-community';
import { OrganizationService } from '../../../services/organization.service';

@Component({
  selector: 'app-organization-list',
  imports: [RouterModule, CommonModule, FormsModule, AgGridModule],
  templateUrl: './organization-list.component.html',
  styleUrl: './organization-list.component.scss'
})

export class OrganizationListComponent implements OnInit {

  @ViewChild('deleteConfirmModal') deleteModal!: any;

  modules = [ClientSideRowModelModule, ValidationModule, CustomFilterModule, TextFilterModule, ColumnAutoSizeModule];

  organizations: any[] = [];
  filteredOrganizations: any[] = [];

  searchQuery: any;

  rowSelection: "single" | "multiple" | RowSelectionOptions<any> | undefined;
  gridApi: GridApi | undefined;
  gridOptions: GridOptions | undefined;

  constructor(private service: OrganizationService, private modalService: NgbModal, private router: Router) {
    this.gridOptions = this.initializeGridOptions();
  }

  ngOnInit(): void {
    this.loadOrganizations();
  }


  initializeGridOptions(): GridOptions<any> | undefined {
    return {
      columnDefs: [
        { field: 'id', sortable: true, filter: true, resizable: true, flex: 3 },
        { field: 'name', sortable: true, filter: true, resizable: true, flex: 2},
        {
          field: 'id',
          headerName: 'Actions',
          headerClass: 'header-center',
          cellRenderer: OrganizationActionsCellRenderer,
          cellRendererParams: {
            context: {
              onDeleteAction: this.openDeleteModal.bind(this),
              onEditAction: this.onUpdateItem.bind(this)
            }
          },
          resizable: true,
          width: 110,
          pinned: 'right'
        }
      ],
      theme: themeAlpine,
      autoSizeStrategy: {
        type: 'fitCellContents'
      }
    };
  }

  openDeleteModal(item: any) {
    this.deleteModal.idToDelete = item.id;
    this.modalService.open(this.deleteModal, { centered: true });
  }

  onUpdateItem(item: any): void {
    this.router.navigate(['/organizations/edit', item.id]);
  }

  clearSearch() {
    this.searchQuery = '';
    this.filteredOrganizations = [...this.organizations];
  }

  filterOrganizations() {
    const query = this.searchQuery.toLowerCase();
    this.filteredOrganizations = this.organizations.filter(item =>
      Object.values(item).some(value =>
        value?.toString().toLowerCase().includes(query)
      )
    );
  }
  confirmDeleteItem(_t23: any) {
    throw new Error('Method not implemented.');
  }

  onGridReady(params: any) {
    this.gridApi = params.api;  
  }

  loadOrganizations() {
    this.gridApi?.setGridOption('loading', true);
    this.service.getAll().subscribe({
      next: (data: any[]) => {
        this.organizations = data;
        this.filteredOrganizations = [...this.organizations];
        this.gridApi?.setGridOption("rowData", this.filteredOrganizations);      
      },
      complete: () => this.gridApi?.setGridOption('loading', false),
      error: (error: any) => {
        console.error('Error fetching organizations:', error);
        this.gridApi?.setGridOption('loading', false);
      }
    });
  }

}

@Component({
  standalone: true,
  template: `
    <button class="btn btn-sm btn-primary me-1" (click)="onEdit()"><i class="bi bi-pencil"></i></button>
    <button class="btn btn-sm btn-danger" (click)="onDelete()"><i class="bi bi-trash"></i></button>
  `
})
export class OrganizationActionsCellRenderer implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  onDelete() { this.params.context.onDeleteAction(this.params.data); }
  onEdit() { this.params.context.onEditAction(this.params.data); }
  refresh(params: ICellRendererParams) { return true; }
}